var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedForMobileToggler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.589 0 0 3.589 0 8C0 9.7405 0.557 11.4005 1.611 12.801L1.7605 13H14.239L14.389 12.801C15.443 11.4005 16 9.7405 16 8C16 3.589 12.411 0 8 0ZM8.5 1.5V3H7.5V1.5H8.5ZM1.5 8.5H3V7.5H1.5V8.5ZM4.11096 4.81797L3.05046 3.75747L3.75746 3.04997L4.81796 4.11047L4.11096 4.81797ZM7.1455 8.41096C7.373 8.91446 7.965 9.13796 8.4685 8.91096C8.972 8.68396 9.196 8.09146 8.9685 7.58846C8.7415 7.08496 6 3.44246 6 3.44246C6 3.44246 6.9185 7.90796 7.1455 8.41096ZM11.8891 4.81797L11.1821 4.11097L12.2426 3.04997L12.9496 3.75697L11.8891 4.81797ZM14.5 7.5H13V8.5H14.5V7.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedForMobileToggler);
export default __webpack_public_path__ + "static/media/SpeedForMobileToggler.4bca44dc.svg";
export { ForwardRef as ReactComponent };